import { AxiosError, isAxiosError } from 'axios';

interface ISignUpRateLimitedResponse {
  message?: string;
  error?: string;
}

export class SignUpRateLimitedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SignUpRateLimitedError';
  }

  static fromAxiosError(error: unknown): SignUpRateLimitedError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<ISignUpRateLimitedResponse>;

    if (axiosError.response?.status === 429) {
      const message =
        axiosError.response.data?.message ||
        axiosError.response.data?.error ||
        'Too many attempts, please try again in a few minutes.';
      return new SignUpRateLimitedError(message);
    }

    return null;
  }
}
